import { useEffect, useState } from "react";
import { Typography, Card, Tabs, Tab, Box} from "@mui/material";
import { frontend, backend, database, TechnologyInterface, devops, other } from "./KnownTechSection.helpers";
import KnownTechPanel from "./KnownTechPanel";
import useIsMobile from "../AppHelpers";

export interface Education {
    jobTitle: string,
    company: string,
    lengthOfService: number,
    briefDescription: string,
    description: string,
    projects?: string[],
    languages?: string[],
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel=(props: TabPanelProps)=> {
  const { children, value, index, ...other } = props;


  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const a11yProps=(index: number)=>{
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const KnownTechSection = ()=> {
  const [value, setValue] = useState(0);
  const [frontendTech, setFrontend] = useState<TechnologyInterface[]>();
  const [databaseTech, setDatabase] = useState<TechnologyInterface[]>();
  const [backendTech, setBackend] = useState<TechnologyInterface[]>();
  const [devopsTech, setDevOps] = useState<TechnologyInterface[]>();
  const [otherTech, setOther] = useState<TechnologyInterface[]>();
  const isMobile = useIsMobile()

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(()=>{
    setFrontend(frontend)
    setBackend(backend)
    setDatabase(database)
    setDevOps(devops)
    setOther(other)
  },[])
    const getAllowedWidth =()=>{
        return isMobile ? '90vw':'80vw'
    }

    return (
      <Card id='known_tech' className="CareerSection ma-2" raised={true} sx={{backgroundColor:'#420A02', color: '#fff', width:{getAllowedWidth}, margin:'2rem', padding:'2rem'}}>
        <Typography variant="h3" className='mb-0' align={'left'} sx={{color: '#fff', marginBottom:'0.5em'}}>Known Technologies</Typography>
             <Box
      sx={{ flexGrow: 1, bgcolor: 'antiqueWhite', display: 'flex' }}
    >
                  <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Known Technology"
        indicatorColor='primary'
        sx={{ borderRight: 1, borderColor: 'divider', color:'primary'}}
      >
                    <Tab label="Frontend" {...a11yProps(0)} />
                    <Tab label="Backend" {...a11yProps(1)} />
                    <Tab label="Database" {...a11yProps(2)} />
                    <Tab label="Devops" {...a11yProps(3)} />
                    <Tab label="Misc" {...a11yProps(4)} />
                </Tabs>
                <TabPanel value={value} index={0}>
                  {frontendTech && <KnownTechPanel technology={frontendTech} title={'Frontend'}></KnownTechPanel>}
                </TabPanel>

                <TabPanel value={value} index={1}>
                  {backendTech && <KnownTechPanel technology={backendTech} title={'Backend'}></KnownTechPanel>}
                </TabPanel>

                <TabPanel value={value} index={2}>
                  {databaseTech && <KnownTechPanel technology={databaseTech} title={'Database'}></KnownTechPanel>}
                </TabPanel>
                 <TabPanel value={value} index={3}>
                  {devopsTech && <KnownTechPanel technology={devopsTech} title={'Devops'}></KnownTechPanel>}
                </TabPanel>
                <TabPanel value={value} index={4}>
                  {otherTech && <KnownTechPanel technology={otherTech} title={'Misc'}></KnownTechPanel>}
                </TabPanel>
                </Box>
        </Card>
    );
  }
  
  export default KnownTechSection;